import CategoryResult from './CategoryResult';

export default CategoryResult;
